export default {
  retrievedCompanies: (state, companies) => {
    state.companies = companies;
  },

  setCompanies: (state, companies) => {
    state.companies = companies;
  },

  setCompaniesFilter: (state, companiesFilter) => {
    state.companiesFilter = companiesFilter;
  },

  setCompanyTypes: (state, types) => {
    state.companyTypes = types;
  },

  setCompanyStatuses: (state, statuses) => {
    state.companyStatuses = statuses;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
